import { createContext, useContext } from 'react';

export const ExistingProjectRequestSearchContext = createContext();

export const useExistingProjectRequestSearchContext = () =>
  useContext(ExistingProjectRequestSearchContext);

export default ExistingProjectRequestSearchContext;
